import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-left",
  "use": "chevron-left-usage",
  "viewBox": "0 0 21 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 28\" id=\"chevron-left\"><path fill=\"currentColor\" d=\"M18.297 4.703L10 13l8.297 8.297a.99.99 0 010 1.406l-2.594 2.594a.99.99 0 01-1.406 0L2.703 13.703a.99.99 0 010-1.406L14.297.703a.99.99 0 011.406 0l2.594 2.594a.99.99 0 010 1.406z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol